export const geographicalFeeLabelIdMap = { CO: 'geographicalFeeCO' };
